"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Permutation = void 0;
class Permutation {
    constructor(sorted, permutation) {
        this.sorted = sorted;
        this.permutation = permutation;
    }
    static fromFunction(original, sort) {
        const range = original.map((_v, i) => i);
        const permutation = range.sort((a, b) => sort(original[a], original[b]));
        const res = new Permutation([], permutation);
        res.forEach((originalIx, newIx) => {
            res.sorted[newIx] = original[originalIx];
        });
        return res;
    }
    forEach(fn) {
        this.permutation.forEach(fn);
    }
    map(fn) {
        const original = this.sorted.map(fn);
        const res = new Permutation(original, this.permutation);
        return res;
    }
}
exports.Permutation = Permutation;
